export const COLLECTIONS = {
  USERS: 'users',
  POSTS: 'posts',
  STRUCTURES: 'structures',
  STRUCTURE_CLAIMS: 'structureClaims',
  INSURANCE_CHECKLISTS: 'insuranceChecklists',
  STRUCTURE_PROGRESS: 'structureChecklistProgress',
  SERVICE_AREAS: 'serviceAreas',
  // Top-level collection: checklistThreads/{structureId}_{itemId}/messages/{messageId}
  CHECKLIST_THREADS: 'checklistThreads',
  CHECKLIST_THREAD_MESSAGES: 'messages',
  NOTIFICATIONS: 'notifications',
  DEVICES: 'devices', // subcollection under USERS
  DEFENSE_PLANS: 'defensePlans',
  // Subcollections under DEFENSE_PLANS, all keyed under defensePlans/{planId}:
  //   parties/{partyId}                — a responsible party
  //   partyContacts/{partyId}          — owner-private email for a party
  //   assignments/{featureId}__{partyId} — one feature/party link
  //   assignmentUpdates/{updateId}     — reported progress on an assignment
  //     (Sept 2026 update loop); read-only to every client, written only by
  //     the requestPlanUpdate/planUpdateLink/publishPlanUpdateNews Cloud
  //     Functions — see src/api/defensePlanUpdates.ts
  DEFENSE_PLAN_PARTIES: 'parties',
  DEFENSE_PLAN_PARTY_CONTACTS: 'partyContacts',
  DEFENSE_PLAN_ASSIGNMENTS: 'assignments',
  DEFENSE_PLAN_ASSIGNMENT_UPDATES: 'assignmentUpdates',
  // Oct 2026: vendor bids on a bundle, bids/{sha256(bundleId + email)}.
  // Owner-read only; written only by the submitBid Cloud Function, except
  // the owner moving one to accepted or declined.
  DEFENSE_PLAN_BIDS: 'bids',
  // Top-level, Oct 2026: planEvents/{eventId} links to one or more plan
  // bundles; sign-ups in planEvents/{eventId}/rsvps/{sha256(email)} are
  // owner-read only and written only by the rsvpToPlanEvent Cloud Function.
  PLAN_EVENTS: 'planEvents',
  PLAN_EVENT_RSVPS: 'rsvps',
  MAP_OVERLAYS: 'mapOverlays',
  FUNDING_SOURCES: 'fundingSources',
  // Moderator-managed people directory ("who's responsible" People button,
  // Sept 2026): name/role/organization/phone/email for players in an area.
  // Never public — see the validAreaContactFields() comment in
  // firestore.rules.
  AREA_CONTACTS: 'areaContacts',
  // Weekly program brief per area (Oct 2026): written only by the
  // generateAreaBrief Cloud Function, read only by moderators.
  AREA_BRIEFS: 'areaBriefs',
  // Private, owner-only spreadsheets of leaders a user uploads (Oct 2026):
  // peopleLists/{listId} with people/{personId} below it. Never read by a
  // Cloud Function, and nobody on a list is emailed from it.
  PEOPLE_LISTS: 'peopleLists',
  PEOPLE_LIST_PEOPLE: 'people',
  // Redi bucks, simulated money (Oct 2026): funds/{fundId} with ledger/{entryId}
  // below it, and fundingRequests/{planId__bundleId__bidId}. Moderators write
  // funds; the ledger, the requests and the fund counters are written only by
  // the requestFunding and reviewFundingRequest Cloud Functions.
  FUNDS: 'funds',
  FUND_LEDGER: 'ledger',
  FUNDING_REQUESTS: 'fundingRequests',
  // Shared vendor directory (Nov 2026): vendors/{vendorId} is a company,
  // vendorReps/{repId} a person at it. Signed-in accounts read approved docs
  // and their own suggestions; moderators review. See docs/vendor-directory.md.
  VENDORS: 'vendors',
  VENDOR_REPS: 'vendorReps',
  VENDOR_EDITS: 'vendorEdits',
  VENDOR_RATINGS: 'vendorRatings',
} as const;
